module.exports = __webpack_public_path__ + "img/bankTransfer2.b83c92c7.png";